export default __webpack_public_path__ + "static/media/sequential-flow-icon.3e191fc4.svg";